import React, { Component } from 'react';
import Layout from '../../../Layouts/DefaultLayout';
import { PostGrid } from '../../../Components';
import { Breadcrumb } from 'react-bootstrap'



class ResourcesViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
            year: [],
            month: [],
            bmos: [],
            industries: []
        }
        document.title = "Bridge Alliance | Events"
    }

    componentDidMount = async () => {
        await this.props.setGeneralData();
        this._setData(1);
    }


    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }

    onPageChange = (pageno) => {
        this._setData(pageno);
    }

    _setData = async (page) => {
        let formdata = {
            "posts_per_page": 12,
            "env": process.env.REACT_APP_MODE,
            "post-type": "post",
            "orderby": "post_modified"
        }
        if (this.state.year.length > 0) {
            formdata["year"] = this.state.year[0];
        } if (this.state.month.length > 0) {
            formdata["month"] = this.state.month[0];
        } if (this.state.bmos.length > 0) {
            formdata["bmos"] = this.state.bmos;
        } if (this.state.industries.length > 0) {
            formdata["industries"] = this.state.industries;
        }

        await this.props.searchPostsJson(
            this.props.token, page, formdata
        );
    }

    _convertSelectedDataToArray = (e) => {
        let ar = [];
        e.forEach(function (element) {
            ar.push(element.value);
        });
        return ar;
    }
    _onChangeSelect = (e, type) => {
        this.setState({ [type]: this._convertSelectedDataToArray(e) }, () => {
            this._setData(1)
        });
    }


    render = () => {
        return (
            <Layout className="inner-page">
                <div className="container">
                    {/*
                    <Breadcrumb className="mt-4">
                        <Breadcrumb.Item href="/resources">Events</Breadcrumb.Item>
                    </Breadcrumb>
                    */}

                    {/* News page changes*/}
                    <h1>News</h1>   

                    <div className="column-inner">
                            <img src="./assets/images/news-card1.png" width="100%" className="mb-4" />
                            <br/><br/>
                            <img src="./assets/images/news-card2.png" width="100%" className="mb-4" />
                            <br/><br/>
                            <img src="./assets/images/news-card3.png" width="100%" className="mb-4" />
                            <br/><br/>
                    </div>
                    <br/><br/><br/>
                   {/* News page changes*/}
                    {/*
                    {(this.props.data !== undefined) && (
                        <PostGrid
                            industries={this.props.industries}
                            years
                            months
                            data={this.props.data ? this.props.data.data : []}
                            selectedData={this.props.data.selected || {}}
                            onChange={this._onChangeSelect}
                            currentpage={parseInt(this.props.data ? this.props.data.currentpage : 0)}
                            max_num_pages={parseInt(this.props.data ? this.props.data.max_num_pages : 0)}
                            isLoading={this.props.isLoading_posts}
                            posttype={`resources`}
                            onPageChange={this.onPageChange}
                        />
                    )}
                    */}



                </div>
            </Layout>
        );
    };



}


/* Export Component ==================================================================== */
export default ResourcesViewContainer;